import { getZod } from '../lib/zodLoader';
import type { z } from 'zod';

// Lazy-loaded schema factory
let cachedSchema: z.ZodObject<any> | null = null;

export async function getBrokerInquirySchema() {
  if (cachedSchema) return cachedSchema;

  const z = await getZod();
  
  cachedSchema = z.object({
    name: z.string().min(2, 'Name must be at least 2 characters'),
    email: z.string().email('Please enter a valid email address'),
    phone: z.string().optional().refine(
      (val) => !val || val.length >= 10,
      'Phone number must be at least 10 digits if provided'
    ),
    preferred_make: z.string().optional(),
    preferred_model: z.string().optional(),
    year_range: z.string().optional(),
    body_type: z.string().optional(),
    budget: z.string().min(1, 'Please select a budget range'),
    timeline: z.string().min(1, 'Please select a timeline'),
    vehicle_details: z.string().max(500, 'Details must be 500 characters or less').optional(),
    preferred_trim: z.string().optional(),
    preferred_color: z.string().optional(),
  });

  return cachedSchema;
}

export type BrokerInquiryData = {
  name: string;
  email: string;
  phone?: string;
  preferred_make?: string;
  preferred_model?: string;
  year_range?: string;
  body_type?: string;
  budget: string;
  timeline: string;
  vehicle_details?: string;
  preferred_trim?: string;
  preferred_color?: string;
};